/**
 * @generated SignedSource<<64735ff474aaed718ae7f07521fcead7>>
 * @relayHash d4fe56bbdc044ed14a906678a10efd9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cfadd2d333ca238f0e702058fd8727b57794b4993667f9eab2f6147aec587b74

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ActivitiesFilterType = "AND" | "OR" | "%future added value";
export type ActivityFilter = {
  actors?: ReadonlyArray<string> | null | undefined;
  arguments?: ActivityFilterArgs | null | undefined;
  rootContainerIds?: ReadonlyArray<string> | null | undefined;
  type?: ActivitiesFilterType | null | undefined;
};
export type ActivityFilterArgs = {
  containerIds?: ReadonlyArray<string> | null | undefined;
  earliestStart?: AGG$DateTime | null | undefined;
  eventTypes?: ReadonlyArray<string> | null | undefined;
  latestStart?: AGG$DateTime | null | undefined;
  objectTypes?: ReadonlyArray<string> | null | undefined;
  products?: ReadonlyArray<string> | null | undefined;
  transitions?: ReadonlyArray<TransitionFilter> | null | undefined;
};
export type TransitionFilter = {
  from: string;
  to: string;
};
export type SmartsRecommendationsQuery = {
  context: SmartsContext;
  excludeInactive?: boolean | null | undefined;
  excludeSelf?: boolean | null | undefined;
  maxNumberOfResults?: number | null | undefined;
  modelRequestParams: SmartsModelRequestParams;
  requestingUserId: string;
  sessionId?: string | null | undefined;
};
export type SmartsContext = {
  additionalContextList?: ReadonlyArray<SmartsKeyValue> | null | undefined;
  containerId?: string | null | undefined;
  objectId?: string | null | undefined;
  product?: string | null | undefined;
  tenantId: string;
  userId: string;
};
export type SmartsKeyValue = {
  key: string;
  value: string;
};
export type SmartsModelRequestParams = {
  caller: string;
  experience: string;
  featureServiceModel?: string | null | undefined;
};
export type singlePersonKnowledgeCardRelayQuery$variables = {
  filter?: ActivityFilter | null | undefined;
  first: number;
  recommendationsQuery: SmartsRecommendationsQuery;
  reportingLinesAaid: string;
  reportingLinesOrgId: string;
  reportingLinesSiteId: string;
  singleUserAccountId: string;
  singleUserRequestingUserId: string;
  singleUserTenantId: string;
};
export type singlePersonKnowledgeCardRelayQuery$data = {
  readonly activity: {
    readonly workedOn: {
      readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_workedOn">;
    };
  } | null | undefined;
  readonly knowledgeDiscovery: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_reportingLines" | "singlePersonKnowledgeCardRelay_user">;
  } | null | undefined;
  readonly smarts: {
    readonly " $fragmentSpreads": FragmentRefs<"singlePersonKnowledgeCardRelay_smarts">;
  } | null | undefined;
};
export type singlePersonKnowledgeCardRelayQuery = {
  response: singlePersonKnowledgeCardRelayQuery$data;
  variables: singlePersonKnowledgeCardRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendationsQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesAaid"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesOrgId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reportingLinesSiteId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserAccountId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserRequestingUserId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "singleUserTenantId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = [
  {
    "kind": "Variable",
    "name": "recommendationsQuery",
    "variableName": "recommendationsQuery"
  }
],
v11 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "singleUserAccountId"
  },
  {
    "kind": "Variable",
    "name": "requestingUserId",
    "variableName": "singleUserRequestingUserId"
  },
  {
    "kind": "Variable",
    "name": "tenantId",
    "variableName": "singleUserTenantId"
  }
],
v12 = [
  {
    "kind": "Variable",
    "name": "aaid",
    "variableName": "reportingLinesAaid"
  },
  {
    "kind": "Variable",
    "name": "orgId",
    "variableName": "reportingLinesOrgId"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "reportingLinesSiteId"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v15 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v14/*: any*/)
  }
],
v16 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = [
  (v16/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": [
      (v16/*: any*/),
      (v17/*: any*/)
    ]
  }
],
v19 = [
  (v17/*: any*/)
],
v20 = {
  "kind": "ScalarField",
  "name": "name"
},
v21 = {
  "kind": "ScalarField",
  "name": "picture"
},
v22 = {
  "kind": "ScalarField",
  "name": "email"
},
v23 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v24 = [
  (v23/*: any*/)
],
v25 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v21/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": (v24/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "singlePersonKnowledgeCardRelay_workedOn"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_smarts"
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_user"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "singlePersonKnowledgeCardRelay_reportingLines"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "singlePersonKnowledgeCardRelayQuery",
    "selections": [
      {
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activity",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "ActivityConnection",
            "kind": "LinkedField",
            "name": "workedOn",
            "plural": false,
            "selections": [
              {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ActivityNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ActivityObject",
                        "kind": "LinkedField",
                        "name": "object",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "data",
                            "plural": false,
                            "selections": [
                              (v13/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluencePageLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluencePage"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceBlogPostLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceBlogPost"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "ConfluenceWhiteboardLinks",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": (v14/*: any*/)
                                  }
                                ],
                                "type": "ConfluenceWhiteboard"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v15/*: any*/),
                                "type": "ConfluenceInlineComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v15/*: any*/),
                                "type": "ConfluenceFooterComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/)
                                ],
                                "type": "JiraIssue"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v18/*: any*/),
                                "type": "JiraPlatformComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v18/*: any*/),
                                "type": "JiraServiceManagementComment"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "ExternalDocument"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "href"
                                  }
                                ],
                                "type": "BitbucketPullRequest"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "loomUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "LoomVideo"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "DevOpsPullRequestDetails"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v19/*: any*/),
                                "type": "MercuryPortfolio"
                              }
                            ]
                          },
                          (v17/*: any*/)
                        ]
                      },
                      (v17/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "SmartsQueryApi",
        "kind": "LinkedField",
        "name": "smarts",
        "plural": false,
        "selections": [
          {
            "args": (v10/*: any*/),
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "accountId"
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v22/*: any*/),
                      {
                        "concreteType": "AtlassianAccountUserExtendedProfile",
                        "kind": "LinkedField",
                        "name": "extendedProfile",
                        "plural": false,
                        "selections": (v24/*: any*/)
                      }
                    ],
                    "type": "AtlassianAccountUser"
                  },
                  (v17/*: any*/)
                ]
              },
              (v17/*: any*/)
            ]
          }
        ]
      },
      {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryUserProfile",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "department"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "organization"
                      },
                      {
                        "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                        "kind": "LinkedField",
                        "name": "thirdPartyIntegrations",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "externalId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "integrationId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "product"
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "KnowledgeDiscoverySingleUser"
              }
            ]
          },
          {
            "args": (v12/*: any*/),
            "kind": "LinkedField",
            "name": "reportingLines",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": (v25/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "managers",
                    "plural": true,
                    "selections": (v25/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": true,
                    "selections": (v25/*: any*/)
                  },
                  {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                    "kind": "LinkedField",
                    "name": "peers",
                    "plural": true,
                    "selections": (v25/*: any*/)
                  }
                ],
                "type": "KnowledgeDiscoveryReportingLines"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cfadd2d333ca238f0e702058fd8727b57794b4993667f9eab2f6147aec587b74",
    "metadata": {},
    "name": "singlePersonKnowledgeCardRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3b96d2345c405f05720744ecd857cd6a";

export default node;
